import type { UrlScope } from "@core/hooks/useRouteParamId";

/** Accessible name for the breadcrumb landmark. */
export const PAGE_BREADCRUMB_ARIA_LABEL = "Breadcrumb";

/** Bootstrap breadcrumb divider character. */
export const PAGE_BREADCRUMB_DIVIDER = "›";

/** Fallback current-page label when a report has no department name yet. */
export const PAGE_BREADCRUMB_REPORT_FALLBACK = "Report";

export const PAGE_BREADCRUMB_LABELS = {
  DEPARTMENTS: "Departments",
  DISTRICTS: "Districts",
  REPORT_TEMPLATES: "Report Templates",
  PRESENTATION_LAYOUTS: "Presentation Layouts",
  DEPARTMENT_REPORTS: "Department Reports",
  PASTOR: "Pastor",
  FINANCE_STATISTICS: "Finance & Statistics",
  ACTIVITY_SUBMISSIONS: "Activity Submissions",
} as const;

/** Path segments appended to an entity base path for breadcrumb parents. */
export const PAGE_BREADCRUMB_PATHS = {
  DEPARTMENTS: "departments",
  DISTRICTS: "districts",
  DEPARTMENT_REPORTS_ALL: "department-reports/all",
  PASTOR_REPORTS_ALL: "leadership-reports/pastor/all",
  FINANCE_STATISTICS_REPORTS_ALL: "leadership-reports/finance-statistics/all",
  ACTIVITY_SUBMISSIONS_ALL: "activity-submissions/all",
} as const;

/** Stable test ids for breadcrumb parents used in page tests. */
export const PAGE_BREADCRUMB_TEST_IDS = {
  DEPARTMENTS_LINK: "breadcrumb-departments-link",
  DISTRICTS_LINK: "breadcrumb-districts-link",
} as const;

/**
 * Entity workspace root for SPA routes, e.g. `/nation/1`, `/church/9`.
 */
export function entityBasePath(scope: UrlScope, scopeId: number): string {
  return `/${scope}/${scopeId}`;
}
